import { render, staticRenderFns } from "./allianceMatching.vue?vue&type=template&id=fa595c32&"
import script from "./allianceMatching.vue?vue&type=script&lang=js&"
export * from "./allianceMatching.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports